const utils = {
  countItemsRecursive(array, filter, childrenKey = 'children') {
    if (!array) {
      return 0
    }

    var count = filter ? array.filter(filter).length : array.length

    array.forEach((item) => {
      count += utils.countItemsRecursive(item[childrenKey], filter)
    })

    return count
  }
}

export default utils
